type NameSourceValue = 'WHATSAPP' | 'CALLER_ID'
type NameSource = {
  value: NameSourceValue
  label: string
}
export default () => {
  const nameSources: Record<NameSourceValue, NameSource> = {
    WHATSAPP: {
      value: 'WHATSAPP',
      label: 'WhatsApp'
    },
    CALLER_ID: {
      value: 'CALLER_ID',
      label: 'Caller\'s ID'
    }
  }
  const getNameSourceText = (value: NameSourceValue): string => {
    return `The contact name was autocompleted with ${nameSources[value]?.label} information. If you want to change it, please edit the contact.`
  }
  return {
    nameSources,
    getNameSourceText
  }
}
